import type { FilterOptionsState } from '@mui/material';

/**
 * Prefix-first filter with Swedish locale sort.
 * Matches are sorted so prefix matches appear before mid-string matches,
 * then alphabetically using Swedish locale (handles å, ä, ö correctly).
 */
export const prefixFirstFilter = (options: string[], { inputValue }: FilterOptionsState<string>): string[] => {
    if (!inputValue) return options;
    const lower = inputValue.toLowerCase();
    const filtered = options.filter(o => o.toLowerCase().includes(lower));
    return filtered.sort((a, b) => {
        const aStarts = a.toLowerCase().startsWith(lower);
        const bStarts = b.toLowerCase().startsWith(lower);
        if (aStarts && !bStarts) return -1;
        if (!aStarts && bStarts) return 1;
        return a.localeCompare(b, 'sv');
    });
};
